// eslint-disable-next-line import/prefer-default-export
export const initialValues = {
  readAccess: false,
  siteRoleId: null,
  writeAccess: false,
};
